import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SuspendedScreen from "@/components/SuspendedScreen";
import ForcePasswordChangeScreen from "@/components/ForcePasswordChangeScreen";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="spinner" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  // Suspended (but not admin) users are blocked from every protected route and
  // shown a dedicated screen instead. Admins are never gated here so they can
  // unsuspend themselves if a misconfiguration ever happens.
  if (user.is_active === false && user.role !== "admin") {
    return <SuspendedScreen />;
  }
  // Users who signed in with an admin-issued temporary password must pick
  // their own password before they can access anything. Admin/FULL_ACCESS
  // are already excluded from this flag in serialize_user().
  if (user.force_password_reset === true) {
    return <ForcePasswordChangeScreen />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
